import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-grid',
  templateUrl: './team-grid.component.html',
  styleUrls: ['./team-grid.component.scss']
})
export class TeamGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
